import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { Box, CircularProgress } from "@mui/material";

interface ChartData {
    name: string;
    views: number;
    fullName: string;
}

interface StatsChartProps {
    data: ChartData[];
    loading: boolean;
}

const StatsChart: React.FC<StatsChartProps> = ({ data, loading }) => {
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                <CircularProgress />
            </Box>
        );
    }

    if (!data || data.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                Нет данных для отображения
            </Box>
        );
    }

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div
                    style={{
                        backgroundColor: "#1a1a1a",
                        border: "1px solid #333",
                        borderRadius: "4px",
                        padding: "8px",
                        color: "#fff",
                    }}
                >
                    <p>{`${data.fullName}`}</p>
                    <p>{`Просмотров: ${payload[0].value.toLocaleString()}`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <Box sx={{ height: 300, mt: 2 }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                    <XAxis
                        dataKey="name"
                        angle={-45}
                        textAnchor="end"
                        height={80}
                        tick={{ fill: "#b0b0b0", fontSize: 12 }}
                    />
                    <YAxis tick={{ fill: "#b0b0b0" }} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="views" fill="#00bcd4" radius={[4, 4, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default StatsChart;
